<template>
  <div class="content_box">
    <div class="content_box_inner">
      <el-row :gutter="10" style="padding-top: 10px">
        <el-col :xs="24" :lg="8">
          <span style="margin-left: 20px"> 时间： </span>
          <el-date-picker
            class="jiance_phone_date"
            :editable="false"
            :clearable="false"
            v-model="times"
            type="month"
            size="mini"
            value-format="yyyy-MM"
            @change="monthChange"
            :picker-options="pickerOptions"
            placeholder="选择月"
          >
          </el-date-picker>
        </el-col>
      </el-row>
    </div>
    <el-link style="margin: 10px 0px" type="primary" @click="exportData">{{
      exportLabel
    }}</el-link>
    <div class="content_box_inner">
      <el-row>
        <el-col :span="24">
          <el-table
            v-loading="loading"
            border
            size="mini"
            :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
            stripe
            :data="tableData"
          >
            <el-table-column type="index" label="序号" width="50" fixed>
            </el-table-column>
            <el-table-column prop="name" label="产品名称" fixed>
            </el-table-column>
            <el-table-column label="趋势" width="50" fixed>
              <template slot-scope="scope">
                <el-link type="primary" @click="showDialog(scope.row)">
                  <i style="font-size: 20px" class="el-icon-data-analysis"></i>
                </el-link>
              </template>
            </el-table-column>
            <el-table-column label="当月数据">
              <el-table-column
                prop="mm_this"
                :formatter="handelFix2"
                sortable
                label="本月"
              >
              </el-table-column>
              <el-table-column
                prop="this_speed"
                :formatter="handelFix1"
                sortable
                label="同比增速(%)"
              >
              </el-table-column>
            </el-table-column>
            <el-table-column label="本年累计">
              <el-table-column
                prop="mm_range"
                :formatter="handelFix2"
                sortable
                label="1-本月"
              >
              </el-table-column>
              <el-table-column
                prop="range_speed"
                :formatter="handelFix1"
                sortable
                label="同比增速(%)"
              >
              </el-table-column>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      :title="`${areaName} - 趋势列表`"
      :visible.sync="dialogTableVisible"
      width="90%"
      @close="closeMe"
      v-if="dialogTableVisible"
    >
      <productContent
        :data-tpye-def="dataTpye"
        :region-code-def="areaName"
        :data-index-def="dataIndex"
        :data-range-def="dataRange"
        :times-def="times"
        :unit="unit"
        :title="areaName"
      ></productContent>
    </el-dialog>
  </div>
</template>
<script>
import productContent from "./productContent";
import { export2Excel } from "@/utils/utils";
export default {
  data() {
    return {
      loading: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      showArea: false,
      areaName: "",
      dialogTableVisible: false,
      exportLabel: "<<点击此处可导出报表",
      queryData: {},
      dataIndexOptions: [
        {
          value: "gyzjz",
          label: "工业增加值",
        },
        {
          value: "yysr",
          label: "营业收入",
        },
        {
          value: "lrze",
          label: "利润总额",
        },
      ],
      dataRangeOptions: [
        {
          value: "month",
          label: "月度",
        },
        {
          value: "quarter",
          label: "季度",
        },
        {
          value: "year",
          label: "年度",
        },
      ],
      dataTpye: "currMonth", //时间类型
      dataIndex: "gyzjz", //数据指标
      dataRange: "month", //数据类型
      times: "", //时间
      unit: "", //时间
      defaultQuarterValue: "", //时间
      defaultMonthValue: "", //时间
      tableData: [],
      areaData: {
        xAxis: [],
        curr: [],
        pre: [],
        profit: [],
      },
    };
  },
  components: {
    productContent,
  },
  watch: {
    dataRange: function (value, oldValue) {
      if (value === "quarter") {
        this.times = this.defaultQuarterValue;
      } else if (value === "month") {
        this.times = this.defaultMonthValue;
      } else {
        this.times = new Date().getFullYear() + "-12";
      }
      this.initData();
    },
  },
  methods: {
    handelFix1(row, column) {
      if (row[column.property] && !isNaN(row[column.property])) {
        return row[column.property].toFixed(1);
      } else {
        return row[column.property];
      }
    },
    handelFix2(row, column) {
      if (row[column.property] && !isNaN(row[column.property])) {
        return row[column.property].toFixed(2);
      } else {
        return row[column.property];
      }
    },
    dataRangeChange(value) {
      if (value === "month") {
        this.dataTpye = "currMonth";
      } else if (value === "quarter") {
        this.dataTpye = "currQuarter";
      } else {
        this.dataTpye = "all";
      }
    },
    showDialog(row) {
      this.showArea = false;
      this.areaName = row.name;
      this.unit = row.name.slice(
        row.name.indexOf("（") + 1,
        row.name.indexOf("）")
      );
      this.dialogTableVisible = true;
    },
    closeMe() {
      this.showArea = true;
      this.dialogTableVisible = false;
    },
    initData() {
      this.loading = true;
      const self = this;
      this.queryData.date = this.times;
      this.$axios
        .post("/business/product/query", this.queryData)
        .then((res) => {
          this.tableData = [];
          this.areaData = {
            xAxis: [],
            curr: [],
            pre: [],
            profit: [],
          };
          this.tableData = res.data;
          this.loading = false;
        });
    },
    getQuarter(value) {
      this.times = value;
      this.initData();
    },
    getNowQuarter() {
      var today = new Date();
      var month = today.getMonth() + 1; //getMonth返回0-11
      var year = today.getFullYear(); //getMonth返回0-11
      if (month < 10) {
        this.defaultMonthValue = year + "-0" + month;
      } else {
        this.defaultMonthValue = year + "-" + month;
      }
      //下面是几个if
      if (month >= 1 && month <= 3)
        return year + "-" + "01" + "," + year + "-" + "03";
      else if (month >= 4 && month <= 6) {
        return year + "-" + "04" + "," + year + "-" + "06";
      } else if (month >= 7 && month <= 9) {
        return year + "-" + "07" + "," + year + "-" + "09";
      } else if (month >= 10 && month <= 12) {
        return year + "-" + "10" + "," + year + "-" + "12";
      }
    },
    yearChange(value) {
      this.times = value + "-12";
      this.initData();
    },
    monthChange(value) {
      this.initData();
    },
    exportData() {
      const column = [
        {
          title: "产品名称",
          key: "name",
          rowspan: 2,
        },
        {
          title: "当月数据",
          data: [
            {
              title: "本月",
              toFixed: 2,
              key: "mm_this",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "this_speed",
            },
          ],
          colspan: 2,
        },
        {
          title: "本年累计",
          data: [
            {
              title: "1-本月",
              toFixed: 2,
              key: "mm_range",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "range_speed",
            },
          ],
          colspan: 2,
        },
      ];
      let timeStr =
        this.times.slice(0, 4) + "年" + this.times.slice(5, 7) + "月";
      export2Excel(column, this.tableData, "产品_" + timeStr);
    },
  },
  created() {
    this.defaultQuarterValue = this.getNowQuarter();
    this.times = this.defaultMonthValue;
    this.initData();
  },
};
</script>
<style lang="less" scoped>
.content_box {
  padding: 20px 30px 30px;
}

.content_box_inner {
  padding: 10px 20px 20px;
  box-shadow: 0px 0px 50px #ccc;
}

@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
  .content_box_inner {
    padding: 10px 10px 20px;
  }
}
</style>